'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.minuteAfter;


// WEBPACK FOOTER //
// ./~/sugar-date/number/minuteAfter.js